import { UnstyledButton, UnstyledButtonProps } from "@mantine/core"

export type DsButtonUnstyledProps = UnstyledButtonProps & {
  onClick?: () => void
}

export function DsButtonUnstyled(props: DsButtonUnstyledProps) {
  return <UnstyledButton {...props} />
}
